function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "About-Us---Desktop-V3",
  transform: "translate(-12.000000, -487.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Hero",
  transform: "translate(0.000000, 72.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "wavoMatic",
  transform: "translate(0.000000, 372.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,128.25 C91.4988064,174.083333 217.745095,197 390.738867,197 C650.229525,197 779.268804,131.916667 968.006304,120 C1093.8313,112.055556 1254.49587,129.605413 1450,172.649573 L1450,43 L12,43 L12,128.25 Z",
  id: "Path",
  fill: "#FFFFFF",
  mask: "url(#mask-2)",
  transform: "translate(731.000000, 120.000000) scale(1, -1) translate(-731.000000, -120.000000) "
})))));

var SvgWave = function SvgWave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 1428 121",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wave.3aafd4d9.svg";
export { ForwardRef as ReactComponent };